import { NavigateFn, Page } from '../../../utils/interfaces/types';
import './NavBar.css';

export interface INavBar {
  navigate: NavigateFn;
  currentPage: Page;
  color?: string;
}

export function NavBar(props: INavBar) {
  return (
    <nav className="nav" style={{ color: props.color }}>
      <button className="nav__logo" onClick={() => props.navigate('home')}>
        Ot Solano
      </button>
      <div className="nav__links">
        <button
          className={`nav__link ${
            props.currentPage === 'projects' ? 'nav__link--active' : ''
          }`}
          onClick={() => props.navigate('projects')}
        >
          Projects
        </button>
        <button
          className={`nav__link ${
            props.currentPage === 'contact' ? 'nav__link--active' : ''
          }`}
          onClick={() => props.navigate('contact')}
        >
          Contact
        </button>
      </div>
    </nav>
  );
}
